import { Component } from '@angular/core';

@Component({
  selector: 'cigna-disabled-page',
  templateUrl: './disabled-page.component.html',
  styleUrls: ['./disabled-page.component.scss'],
})
export class DisabledPageComponent {}
